export const messages = {
  page: {
    title: {
      id: 'patientPortal.Home.Page.Title',
      defaultMessage: 'Dashboard',
    },
  },
  tabs: {
    dashboard: {
      id: 'patientPortal.Home.Tabs.Dashboard',
      defaultMessage: 'Dashboard',
    },
    appointments: {
      id: 'patientPortal.Home.Tabs.Appointments',
      defaultMessage: 'Appointments',
    },
    treatmentsummary: {
      id: 'patientPortal.Home.Tabs.TreatmentSummary',
      defaultMessage: 'Treatments',
    },
    followups: {
      id: 'patientPortal.Home.Tabs.Followups',
      defaultMessage: 'Follow-up Plan',
    },
    education: {
      id: 'patientPortal.Home.Tabs.Education',
      defaultMessage: 'Education',
    },
    testresults: {
      id: 'patientPortal.Home.Tabs.TestResults',
      defaultMessage: 'Test Results',
    },
    medicalnotes: {
      id: 'patientPortal.Home.Tabs.MedicalNotes',
      defaultMessage: 'Medical Notes',
    },
    questionnaires: {
      id: 'patientPortal.Home.Tabs.Questionnaires',
      defaultMessage: 'Questionnaires',
    },
    securemessages: {
      id: 'patientPortal.Home.Tabs.SecureMessages',
      defaultMessage: 'Messages',
    },
    contactus: {
      id: 'patientPortal.Home.Tabs.ContactUs',
      defaultMessage: 'Contact Us',
    },
  },
};
